//  * @package         src/components/Dashboard
//  * @author          Riddhi D Parekh
//  * @date            22nd January 2018
//  * @type            Error Component File
//  * @description -   This file renders the html whenever an invalid url is tried to access from the app.
<template>
  <div id="loadingdiv">
    <p>User Data Invalid</p>
    <!-- <form class="form-signin">
      <h2 class="form-signin-heading">{{ $t("message.hello") }}</h2>
      <p>
          Email: <input :class="{ error: errors.has('email') }" type="text" v-validate="'required|email'" name="email">
          <span v-show="errors.has('email')" class="error">{{ errors.first('email') }}</span>
        </p>
      <input  :class="{ error: errors.has('email') }" v-validate="'email'" data-vv-as="email" type="text" id="inputEmail" class="form-control" :placeholder="$t('message.email')" required autofocus>

      <label for="inputPassword">{{ $t("message.password") }}</label>
      <input type="password" id="inputPassword" class="form-control" :placeholder="$t('message.password')" required>
      <button class="btn btn-lg btn-primary btn-block" type="submit">{{ $t("message.sign_in") }}</button>
    </form>-->
    <button class="btn btn-lg btn-primary" type="submit" @click="hispec">Go Back</button>
  </div>
</template>

<script>
var { frontHostName, redirectUrl } = require("../../config/config.js");
export default {
  data() {
    return {};
  },
  methods: {
    hispec() {
      // var parts = window.location.href.split(".");
      let whitelabel = this.$session.get("whitelabel");
      var loc =
        frontHostName +
        process.env.CAKE_BASE_PATH +
        whitelabel +
        process.env.CAKE_SURVEY_PATH;
      window.location.href = loc;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ErrorPage.vue